export async function getSegment(queryParams) {
  const { idWall, apiKey, apiPaywallURL } = window.LN.PaywallHub;
  const request = `${
    apiPaywallURL
  }/api/paywall/v2/walls/${
    idWall
  }/segments?q=${encodeURIComponent(queryParams)}`;

  return await fetch(request, {
    method: "GET",
    headers: {
      apikey: apiKey,
    },
  })
    .then((response) => response.json())
    .then((data) => data)
    .catch((error) => {
      console.error("Error:", error);
      DD_LOGS?.logger?.error("fetch segments", {
        queryParams,
        WallId: idWall,
        Error: error,
      });
    });
}



// WEBPACK FOOTER //
// ./Statics/scripts/paywall/services/segmentos.js